// extracted by mini-css-extract-plugin
module.exports = {"arrow":"_7a3fb80146--arrow--naTE9"};